import React from 'react';

const SendIcon = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75328 12.149L10.5243 20.118C10.7453 21.111 12.0643 21.325 12.5873 20.453L20.8363 6.704C21.2873 5.954 20.7473 5 19.8723 5H4.32128C3.31828 5 2.81628 6.212 3.52528 6.921L8.75328 12.149Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.84 5.56055L8.75 12.1505"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SendIcon;
